<template>
  <div class="body-div">
    <div class="top-div">
      <under-performing-charts></under-performing-charts>
    </div>
  </div>
</template>

<script>
// import Loader from "../../../../../main/misc.main/loader/Loader";
import UnderPerformingCharts from "../../../graph_sub_feature/components/UnderPerformingCharts.component";
import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
export default {
  name: "UnderPerf.container",
  components: {
    // Loader
    UnderPerformingCharts
  },
  data() {
    return {
      liveStatsBusy: false,
      liveAgentsStats: [],
      liveCallCenterStats: []
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["dictionaries", "salesPersonList"])
  },
  created() {},
  methods: {}
};
</script>

<style scoped>
.body-div {
  padding: 4px 5px 1px 5px;
}
.top-div {
  width: 100%;
  height: max-content;
  margin: auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
}
.bottom-div {
  width: 100%;
  height: 650px;
  overflow-y: scroll;
  margin: 5px auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
  position: relative;
}
.fab {
  background-color: transparent;
  padding: 0;
  font-size: 30px;
  line-height: 30px;
  color: green;
  text-align: center;
  position: absolute;
  right: 10px;
  bottom: 10px;
  border-radius: 20%;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
}

.fab:hover {
  box-shadow: 0 5px 11px 0 #666;
  transform: scale(1.05);
}
table {
  margin: 2em 0;
  display: flex;
  flex-direction: column;
}
.loader {
  left: 0;
  right: 0;
}

.endpoint-calls {
  display: flex;
  justify-content: center;
  padding: 2em 0;
}
.overall-call-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
